<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import '@/assets/css/app.css';
import GlobalErrorNotification from '@/components/GlobalErrorNotification';
import GlobalSuccessNotification from '@/components/GlobalSuccessNotification';

import { useAuthStore } from '@/stores/auth';

import { useGlobalError } from '@/composables/useGlobalError';
import { SplashScreen } from '@capacitor/splash-screen';

const authStore = useAuthStore();
const router = useRouter();
const { globalErrorCode } = useGlobalError();

// Hide splash screen when app is fully loaded
onMounted(async () => {
  try {
    await SplashScreen.hide();
  } catch (error) {
    // SplashScreen plugin may not be available in web mode
    console.log('SplashScreen plugin not available:', error);
  }
});

watch(globalErrorCode, (val) => {
  if (val === 'UNAUTHORIZED' || val === 'FORBIDDEN') {
    authStore.logout();
    router.push('/login');
  }
});
</script>
<template>
  <RouterView />
  <GlobalErrorNotification />
  <GlobalSuccessNotification />
</template>
